import { createFileRoute } from '@tanstack/react-router'
import { listSearchSchema } from '@/lib/list-search-schema'
import RiskAssessments from '@/pages/RiskAssessments'

export const Route = createFileRoute('/_authenticated/risk-assessments')({
  validateSearch: listSearchSchema,
  component: RiskAssessments,
})
